export const replaceListWithParagraphs = (element) => {
  // 检查是否包含ul或li标签
  const hasListElements = element.querySelector("ul, li") !== null;

  if (!hasListElements) {
    return false; // 不包含ul或li标签
  }

  // 替换所有ul和li标签为p标签
  const listElements = element.querySelectorAll("ul, li");
  listElements.forEach((el) => {
    const p = document.createElement("p");

    // 复制所有属性
    Array.from(el.attributes).forEach((attr) => {
      p.setAttribute(attr.name, attr.value);
    });

    // 移动所有子节点
    while (el.firstChild) {
      p.appendChild(el.firstChild);
    }

    // 替换原始元素
    el.parentNode.replaceChild(p, el);
  });

  return true; // 已成功替换
};
// 提取公式
export const extractFormulas = (str) => {
  // const formulas = [];
  // 匹配 $$...$$（块级公式），排除转义的 \$
  // const doubleDollarRegex = /(?<!\\)\$\$(?!\\)([\s\S]*?)(?<!\\)\$\$(?!\\)/g;
  const doubleDollarRegex = /\$\$(.*?)\$\$/gs;
  str = str.replace(doubleDollarRegex, (match) => {
    // 把前后的$$符号去掉
    const value = match.replace(/\$\$/g, "");
    return `<span data-w-e-type="formula" data-w-e-is-void  data-value="${value}"></span>`;
  });
  // const singleDollarRegex = /(?<!\\)\$(?!\\)(.*?)(?<!\\)\$(?!\\)/g;
  const singleDollarRegex = /\$(.*?)\$/gs;
  str = str.replace(singleDollarRegex, (match) => {
    // 把前后的$符号去掉
    const value = match.replace(/\$/g, "");
    return `<span data-w-e-type="formula" data-w-e-is-void  data-value="${value}"></span>`;
  });
  return str;
};
// 处理 \[ ... \] 块级公式
export const replaceMathDelimiters = (str) => {
  return str.replace(/\\\[([\s\S]*?)\\\]/g, (match, content) => {
    return `$${content}$`;
  });
};
export const escapeLatexInString = (input) => {
  // 正则表达式模式匹配行内公式 $...$ 和块级公式 $$...$$
  const pattern = /(\$\$?)([^$]*?)\1/g;

  return input.replace(pattern, (match, delimiter, content) => {
    // 替换公式内容中的单斜杠为双斜杠
    const escapedContent = content.replace(/\\/g, "\\\\");

    // 返回替换后的完整公式
    return `${delimiter}${escapedContent}${delimiter}`;
  });
};
export const sanitizeHtmlLists = (htmlContent) => {
  // 创建 DOM 解析器
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlContent, "text/html");

  // 替换嵌套的列表标签
  function replaceNestedLists(node) {
    if (node.nodeType !== Node.ELEMENT_NODE) return;

    // 处理第一层级的 ul/ol
    if (["ul", "ol"].includes(node.tagName.toLowerCase())) {
      // 处理其直接子节点 li
      Array.from(node.children).forEach((li) => {
        if (li.tagName.toLowerCase() === "li") {
          // 处理 li 内部的所有内容
          processLiContent(li);
        }
      });
      return;
    }

    // 处理其他元素的子节点
    Array.from(node.children).forEach((child) => {
      replaceNestedLists(child);
    });
  }

  // 处理 li 内部的内容，替换嵌套列表
  function processLiContent(liNode) {
    Array.from(liNode.children).forEach((child) => {
      if (["ul", "ol", "li", "p"].includes(child.tagName.toLowerCase())) {
        // 替换嵌套的列表标签为 p
        const pNode = document.createElement("span");

        // 复制属性
        Array.from(child.attributes).forEach((attr) => {
          pNode.setAttribute(attr.name, attr.value);
        });

        // 移动子节点
        while (child.firstChild) {
          pNode.appendChild(child.firstChild);
        }

        // 替换节点
        liNode.replaceChild(pNode, child);

        // 继续处理新创建的 p 内部的内容
        processLiContent(pNode);
      } else {
        // 递归处理其他子节点
        processLiContent(child);
      }
    });
  }

  // 从 body 开始处理
  replaceNestedLists(doc.body);

  // 返回处理后的 HTML
  return doc.body.innerHTML;
};
export const processListItemHtml = (htmlString) => {
  // 创建 DOM 解析器
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlString, "text/html");
  // 查找所有 <li> 元素
  const listItems = doc.querySelectorAll("li");

  listItems.forEach((li) => {
    // 检查 <li> 是否同时包含 <ul> 和其他元素
    const hasUl = li.querySelector("ul");
    const hasOtherElements = Array.from(li.childNodes).some(
      (node) =>
        (node.nodeType === 1 && node.tagName !== "UL") ||
        (node.nodeType === 3 && node.textContent.trim() !== "")
    );

    if (hasUl && hasOtherElements) {
      // 替换所有 <ul> 为 <div class="nested-content">
      const ulElements = li.querySelectorAll("ul");
      ulElements.forEach((ul) => {
        const div = doc.createElement("div");
        div.className = "nested-content";

        // 复制 <ul> 的所有属性到 <div>
        Array.from(ul.attributes).forEach((attr) => {
          div.setAttribute(attr.name, attr.value);
        });

        // 将 <ul> 的子元素移动到 <div>
        while (ul.firstChild) {
          div.appendChild(ul.firstChild);
        }

        // 替换 <ul> 为 <div>
        ul.parentNode.replaceChild(div, ul);
      });
    }
  });
  // 返回处理后的 HTML 字符串
  return doc.body.innerHTML;
};
export const htmlToSlate = (htmlString, editor) => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlString, "text/html");
  const body = doc.body;
  return domToSlate(body, editor);
};
// 递归将 DOM 节点转换为 Slate 节点
function domToSlate(domNode, editor) {
  // 处理文本节点
  if (domNode.nodeType === Node.TEXT_NODE) {
    // 过滤掉纯空白文本节点
    const text = domNode.textContent.trim();
    if (text === "") return null;
    return { text };
  }

  // 处理元素节点
  if (domNode.nodeType === Node.ELEMENT_NODE) {
    const { tagName } = domNode;

    // 处理公式元素
    if (tagName === "SPAN" && domNode.dataset?.wEType === "formula") {
      return {
        type: "formula",
        value: domNode.dataset.value || "",
        children: [{ text: "" }],
      };
    }

    // 处理列表元素
    if (tagName === "UL" || tagName === "OL") {
      let children = [];

      Array.from(domNode.childNodes).forEach((child) => {
        if (child.tagName === "LI") {
          const liChildren = domToSlate(child, editor);

          if (liChildren) {
            if (Array.isArray(liChildren)) {
              children = [...children, ...liChildren];
            } else {
              children.push(liChildren);
            }
          }
        }
      });

      return children;
    }

    // 处理列表项
    if (tagName === "LI") {
      let children = [];

      Array.from(domNode.childNodes).forEach((child) => {
        const childNode = domToSlate(child, editor);

        if (childNode) {
          if (Array.isArray(childNode)) {
            children = [...children, ...childNode];
          } else {
            children.push(childNode);
          }
        }
      });

      return children;
    }

    // 处理嵌套内容容器
    if (tagName === "DIV" && domNode.classList.contains("nested-content")) {
      let children = [];

      Array.from(domNode.childNodes).forEach((child) => {
        const childNode = domToSlate(child, editor);

        if (childNode) {
          if (Array.isArray(childNode)) {
            children = [...children, ...childNode];
          } else {
            children.push(childNode);
          }
        }
      });

      return children;
    }

    // 处理段落和标题
    if (tagName === "P" || tagName.startsWith("H")) {
      let children = [];

      Array.from(domNode.childNodes).forEach((child) => {
        const childNode = domToSlate(child, editor);

        if (childNode) {
          if (Array.isArray(childNode)) {
            children = [...children, ...childNode];
          } else {
            children.push(childNode);
          }
        }
      });

      return children;
    }

    // 处理其他标签
    let children = [];

    Array.from(domNode.childNodes).forEach((child) => {
      const childNode = domToSlate(child, editor);

      if (childNode) {
        if (Array.isArray(childNode)) {
          children = [...children, ...childNode];
        } else {
          children.push(childNode);
        }
      }
    });

    return children;
  }

  return null;
}
